<template>
  <div class="main-content container-fluid fixed">
    <div class="purchase-history-page row">
      <div class="col-1"></div>
      <main class="col-8">
        <div class="basic-information row">
          <div class="col-5 basic-information__personal">
            <div class="personal-status">
              <div class="personal-status__title">會員資訊</div>
              <div class="personal-status__payment" v-show="is_owe">
                欠費 {{ oweMoney }}
              </div>
              <button
                class="personal-status__rebtn"
                @click="attemptReselectMember"
              >
                重新選擇會員
              </button>
            </div>
            <div class="personal-private-info">
              <div class="personal-private-info__people d-flex">
                <div class="personal-private-info__people-img">
                  <img :src="member.avatar" alt="" />
                </div>
                <div class="personal-private-info__people-contact">
                  <h4 class="name">
                    <!-- <p class="user-company">
                      美情健康股份有限...
                      <span class="icon-icn_company"></span>
                    </p> -->

                    <p class="user-personal">
                      {{ member.name }}
                      <span :class="memberTypeClass"></span>
                    </p>
                  </h4>
                  <p class="mobile">{{ member.phone }}</p>
                  <p v-show="showMemberLevel" class="member-level">
                    會員等級{{ member.level.name }}
                  </p>
                </div>
              </div>

              <div class="number-area">
                <div class="number-area__item serial">
                  <div class="number-area__item-title">
                    會員編號
                  </div>
                  <div class="number-area__item-content">
                    {{ member.no }}
                  </div>
                </div>
                <div class="number-area__item">
                  <div v-if="member.type == 2" class="number-area__item-title">
                    統編
                  </div>
                  <div v-else class="number-area__item-title">
                    生日
                  </div>
                  <div class="number-area__item-content">
                    {{ birthdayOrTax }}
                  </div>
                </div>
                <div class="number-area__item">
                  <div class="number-area__item-title">
                    建立日期
                  </div>
                  <div class="number-area__item-content">
                    {{ member.created_at }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-7 purchase-plan">
            <div class="purchase-plan-status">
              <div class="purchase-plan-status__title">上期購買方案</div>
              <div
                v-show="checkLastProgramStatus"
                class="purchase-plan-status__expire"
              >
                已到期
              </div>
            </div>
            <div class="purchase-plan-detail row">
              <div class="col-6">
                <div class="detail-item">
                  <div class="detail-item__title">
                    購買日期
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.created_at }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    方案名稱
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.program_name }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    計費方式
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgramType }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    月期數/堂數
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.program_number }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    適用分店群組
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.group_name }}
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="detail-item">
                  <div class="detail-item__title">
                    價格
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.program_price }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    贈送次數
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.giveaway_number }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    {{ limitOrEndName }}
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ limitOrEnd }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    已使用次數
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.used_number }}
                  </div>
                </div>

                <div class="detail-item">
                  <div class="detail-item__title">
                    可使用次數
                  </div>
                  <div class="detail-item__content" v-if="lastProgram">
                    {{ lastProgram.last_number }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="purchase-record">
          <div class="function-row">
            <div class="function-row__title">
              歷史購買紀錄
            </div>
            <div class="function-row__search-bar">
              <i class="fas fa-search"></i>
              <input
                type="text"
                placeholder="訂單搜尋"
                v-model="search_name"
                @blur="resetOrderList"
                @keydown.enter="resetOrderList"
              />
            </div>
            <div class="function-row__owe-money">
              <input
                class="custom-checkbox"
                id="owe"
                type="checkbox"
                value="owe"
                v-model="owe"
              />
              <label for="owe">欠費</label>
            </div>
          </div>
          <div
            class="purchase-list"
            v-for="order in orders"
            :key="order.order_id"
          >
            <OneList :order="order" />
          </div>
          <infinite-loading @infinite="infiniteHandler" ref="loadingComponent">
            <template v-slot:no-results>
              <p>已無更多資訊</p>
            </template>
            <template v-slot:no-more>
              <p>已無更多資訊</p>
            </template>
          </infinite-loading>
        </div>
      </main>
      <SidebarMenu :memberId="member.member_id" />
    </div>
  </div>
</template>

<script>
import SidebarMenu from '@/components/Layouts/SidebarMenu';
import OneList from '@/components/PurchaseHistory/OneList';
import { fetchMemberLastProgram } from '@/api/program';
import { fetchMemberOrders } from '@/api/order';
import { fetchMemberById } from '@/api/member';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  components: {
    SidebarMenu,
    OneList
  },
  data() {
    return {
      member: {
        level: {}
      },
      lastProgram: {},
      orders: [],
      search_name: '',
      owe: null,
      is_owe: false,
      page: 0,
      total: 0
    };
  },
  computed: {
    ...mapState('user', ['userClickBranch']),
    ...mapGetters('member', ['isChoose']),
    checkMemberGender() {
      if (this.member.type == 1 && this.member.gender == 0) {
        return false;
      } else if (this.member.type == 1 && this.member.gender == 1) {
        return true;
      }

      return false;
    },
    checkLastProgramStatus() {
      if (
        this.lastProgram &&
        (this.lastProgram.status == 2 || this.lastProgram.status == 3)
      ) {
        return true;
      }

      return false;
    },
    oweMoney() {
      let sum = 0;

      if (this.orders) {
        for (let index = 0; index < this.orders.length; index++) {
          sum += this.orders[index].unpaid_amount;
        }
      }

      this.setOweStatus(sum);

      return sum;
    },
    lastProgramType() {
      switch (this.lastProgram.program_type) {
        case '1':
          return '包月';
        case '2':
          return '計次';
        case '3':
          return '訂閱制';
        default:
          return null;
      }
    },
    birthdayOrTax() {
      if (this.member.type == 2) {
        return this.member.tax_number;
      }

      return this.member.birthday;
    },
    showMemberLevel() {
      if (this.member.type == 2) {
        return false;
      }

      return true;
    },
    memberTypeClass() {
      if (this.member.type == 2) {
        return 'icon-icn_company';
      } else {
        return this.member.gender == 1 ? 'icon-icn_man' : 'icon-icn_woman';
      }
    },
    // 未啟用抓啟用期限,已啟用抓使用期限名稱
    limitOrEndName() {
      if (this.lastProgram && this.lastProgram.start_at == null) {
        return '啟用期限';
      }

      return '使用期限';
    },
    // 未啟用抓啟用期限,已啟用抓使用期限日期
    limitOrEnd() {
      if (this.lastProgram && this.lastProgram.start_at == null) {
        return this.lastProgram.limit_at;
      }

      return this.lastProgram.end_at;
    }
  },
  watch: {
    owe() {
      this.resetOrderList();
    }
  },
  created() {
    if (this.isChoose) {
      this.attemptFetchMemberById();
      this.fetchMemberLastProgram();
    } else {
      this.returnChoosePage();
    }
    let branchName = localStorage.getItem('branchName');
    if (branchName !== this.userClickBranch) {
      this.setUserClickBranch(branchName);
    }
  },
  methods: {
    ...mapMutations('user', ['setUserClickBranch']),
    ...mapActions('member', ['reselectMember']),

    infiniteHandler($state) {
      const get_owe = this.owe ? true : null;
      this.page += 1;

      fetchMemberOrders(
        {
          page: this.page,
          search_name: this.search_name,
          owe_money: get_owe
        },
        res => {
          this.orders.push(...res.data);
          if (res.current_page !== res.last_page) {
            $state.loaded();
          } else {
            $state.complete();
          }
        }
      );
    },
    resetOrderList() {
      this.page = 0;
      this.orders = [];
      this.$refs.loadingComponent.stateChanger.reset();
    },
    attemptFetchMemberById() {
      fetchMemberById(memberCb => {
        this.member = memberCb;
      });
    },
    fetchMemberLastProgram() {
      fetchMemberLastProgram(lastProgramCb => {
        this.lastProgram = lastProgramCb;
      });
    },
    attemptReselectMember() {
      this.reselectMember(this.returnChoosePage());
    },
    returnChoosePage() {
      this.$router.push({ name: '銷售' });
    },
    setOweStatus(sum) {
      if (sum != 0) {
        this.is_owe = true;
      }
    }
  }
};
</script>
